import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormlyFieldDatepicker } from './datepicker.type';
import { FormlyFormFieldModule } from '../form-field/public_api';

@NgModule({
    declarations: [FormlyFieldDatepicker],
    imports: [
        CommonModule,
        DateInputsModule,
        ReactiveFormsModule,

        FormlyFormFieldModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'kendo-datepicker',
                    component: FormlyFieldDatepicker,
                    wrappers: ['simple-form-field']
                },
                {
                    name: 'kendo-datepickerTime',
                    extends: 'kendo-datepicker'
                },
                {
                    name: 'kendo-monthDatepicker',
                    extends: 'kendo-datepicker'
                },
                {
                    name: 'kendo-yearDatepicker',
                    extends: 'kendo-datepicker'
                }
            ],
        }),
    ],
})
export class FormlyDatepickerModule { }
